const middleware = {}

middleware['authentication'] = require('../middleware/authentication.js')
middleware['authentication'] = middleware['authentication'].default || middleware['authentication']

middleware['global'] = require('../middleware/global.js')
middleware['global'] = middleware['global'].default || middleware['global']

export default middleware
